import React from 'react';
import {
    AdminIcon,
    TypeCustomerIcon,
    TypeDistributorIcon,
    TypeResellerIcon
} from '../../../utils/SVGIcon';

function UserRoleIconPicker({ role }) {
    if (role === 'customer') {
        return (
            <div>
                <TypeCustomerIcon />
            </div>
        );
    }
    if (role === 'distributor') {
        return (
            <div>
                <TypeDistributorIcon />
            </div>
        );
    }
    if (role === 'agency') {
        return (
            <div>
                <TypeResellerIcon />
            </div>
        );
    }
    if (role === 'reseller') {
        return (
            <div>
                <TypeResellerIcon />
            </div>
        );
    }
    if (role === 'admin') {
        return (
            <div className="w-4">
                <AdminIcon className="opacity-35" />
            </div>
        );
    }
    return null;
}

export default UserRoleIconPicker;
